// @/services/content/store/modules/scm-export.js
/**
 * ScmExportHandler 
 * 
 * Handles content retrieval for SCM CSV Export functionality
 * Provides locale-specific content for column headers and value labels with proper fallbacks
 */
export class ScmExportHandler {
  constructor(store) {
    this.store = store;
  }

  /**
   * Get SCM Export content by locale
   * @param {string} locale Locale to get content for (defaults to 'en')
   * @returns {Object|null} Content or null if not found
   */
  getContent(locale = 'en') {
    // Try requested locale first
    const localeContent = this.store.state.data.scmExport?.[locale];
    if (localeContent) return localeContent;
    
    // Fall back to English if different locale was requested
    if (locale !== 'en') {
      return this.store.state.data.scmExport?.['en'] || null;
    }
    
    return null;
  }
  
  /**
   * Get specific localized value with fallbacks
   * @param {string} key The content key to retrieve
   * @param {string} locale The locale to try first
   * @param {string} defaultValue Optional default if no translations found
   * @returns {string} The localized value or default
   */
  getText(key, locale = 'en', defaultValue = '') {
    // Try the requested locale first
    const localeContent = this.getContent(locale);
    
    if (localeContent && localeContent[key]) {
      return localeContent[key];
    }
    
    // Fall back to English if different locale was requested
    if (locale !== 'en') {
      const englishContent = this.getContent('en');
      if (englishContent && englishContent[key]) {
        return englishContent[key];
      }
    }
    
    // Return default if no translations found
    return defaultValue;
  }
}
